import type { Account } from '@ps/web-core-store';

import {
  TXTCLI_Please_try_againX,
  TXTCLI_The_SSN_that_you_have_entered__ELL
} from '../translations';

export const compareWithNatNumber = (
  value: string,
  nationalDocumentNumber: Account['nationalDocumentNumber']
) => {
  if (!nationalDocumentNumber) return { valid: true };

  if (Number(value) !== Number(nationalDocumentNumber)) {
    return {
      valid: false,
      message: [TXTCLI_The_SSN_that_you_have_entered__ELL, TXTCLI_Please_try_againX]
    };
  }

  return {
    valid: true
  };
};
